export const  ip: string = 'https://localhost';
export const port: string = '8443';
//export const urlServer: string =ip.concat(":",port);
export const urlServer: string ='https://www.masterfield.ma';



export const msSectorIp: string = 'https://masterfield.itimdex.com';
export const msPort: string = '8071';
//export const msUrlServer: string =msSectorIp;
export const msUrlServer: string =urlServer;

export const msIp: string = 'https://localhost';
export const msSurveyPort: string = '8073';
//export const msSurveyUrlServer: string =msIp.concat(":",msSurveyPort);
export const msSurveyUrlServer: string =urlServer;

export const msLeavePort: string = '8181';
//export const msLeaveUrlServer: string =msIp.concat(":",msLeavePort);
export const msLeaveUrlServer: string =urlServer;

export const msHelpPort: string = '8888';
//export const msHelpUrlServer: string =msIp.concat(":",msHelpPort);
export const msHelpUrlServer: string =urlServer;


export const msMessagePort: string = '8585';
//export const msMessageUrlServer: string =msIp.concat(":",msMessagePort);
export const msMessageUrlServer: string =urlServer;

